import { FC } from 'react';
import { ContextType, TableDataContext } from './TableDataContext';

export const TableDataProvider: FC<ContextType> = ({ children, tableData, tableId }) => (
  <TableDataContext.Provider value={{ tableData, tableId }}>{children}</TableDataContext.Provider>
);
